//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PwrFormRow',
  props: {
    label: {
      type: String,
      default: null,
    },
    cols: {
      type: Number,
      default: null,
    },
    sm: {
      type: Number,
      default: null,
    },
    md: {
      type: Number,
      default: null,
    },
    lg: {
      type: Number,
      default: null,
    },
    xl: {
      type: Number,
      default: null,
    },
  },
};
